import React, { useState } from "react";
import "./navbar.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import appLogo from "../../Media/zzz.png";
import { Link } from "react-router-dom";
import { useUserAuth } from "../../Context/UseAuthContext";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import Login from "../../Pages/LogInPage/Login";
import Profile from "../../containers/Profile/Profile";
import AccountSettings from "../../Settings/AccountSettings";

const ProfileNavbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [navbar, setnavbar] = useState(false);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { currentUser, setModal, logOut } = useUserAuth();
  const openLogin = () => {
    setModal({ isOpen: true, title: "Login", content: <Login /> });
  };

  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/login");
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const changeBackground = () => {
    if (window.scrollY >= 60) {
      setnavbar(true);
    } else {
      setnavbar(false);
    }
  };
  window.addEventListener("scroll", changeBackground);
  return (
    <nav className="navbar active">
      <div className="navbar-logo">
        <Link to="/">
          <img src={appLogo} className="logo" alt="applogo" />
        </Link>
      </div>

      <ul className="navbar-links">
        {/* <li>
          <a href="#about">About</a>
        </li> */}
        <li>
          <Link to="/emergency">Emergency</Link>
        </li>
        <li>
          <Link to="/dash">Dashboad</Link>
        </li>
        {/* <li>
          <Link to="/jobspage">Therapist Jobs</Link>
        </li> */}
      </ul>
      <div className="navbar-login">
        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          {!currentUser ? (
            <div>
              <Link to="/login" className="sidebtns" onClick={openLogin}>
                Log In / Register
              </Link>

              <a
                href="/start"
                style={{
                  backgroundColor: isHovering ? "salmon" : "white",
                  color: isHovering ? "white" : "rgb(2, 168, 184)",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="sidebtns getstarted"
              >
                Get Started
              </a>
            </div>
          ) : (
            <Tooltip title="Account settings">
              <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                <Avatar
                  style={{ border: "2px solid white", background: "salmon" }}
                  sx={{ width: 35, height: 35 }}
                  src={currentUser?.photoURL}
                >
                  {currentUser?.displayName?.charAt(0)?.toUpperCase() ||
                    currentUser?.email?.charAt(0)?.toUpperCase()}
                </Avatar>
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={() =>
              setModal({
                isOpen: true,
                title: "Update Profile",
                content: <Profile />,
              })
            }
          >
            <Avatar src={currentUser?.photoURL} /> Profile
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() =>
              setModal({
                isOpen: true,
                title: "Account Settings",
                content: <AccountSettings />,
              })
            }
          >
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>

        <div />
      </div>

      <div className="navbar-smallscreen">
        <GiHamburgerMenu
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu(true)}
        />

        {toggleMenu && (
          <div className="navbar-smallscreen_overlay">
            <ImCross
              fontSize={27}
              className="overlay__close"
              onClick={() => setToggleMenu(false)}
            />
            <ul className="navbar-smallscreen_links">
              <li className="p__opensans">
                <Link to="/" onClick={() => setToggleMenu(false)}>
                  Home
                </Link>
              </li>
              {/* <li className="p__opensans">
                <a href="#about" onClick={() => setToggleMenu(false)}>
                  About
                </a>
              </li> */}
              <li>
                <Link to="/emergency" onClick={() => setToggleMenu(false)}>
                  Emergency
                </Link>
              </li>
              <li className="p__opensans">
                <Link to="/dash" onClick={() => setToggleMenu(false)}>
                  Dashboad
                </Link>
              </li>
              {/* <li className="p__opensans">
                <Link to="/jobspage" onClick={() => setToggleMenu(false)}>
                  Therapist Jobs
                </Link>
              </li> */}
            </ul>

            <div className="navbar-smallscreen-login">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {!currentUser ? (
                  <div className="smallscreen-sidebtns">
                    <Link
                      to="/login"
                      className="login-small"
                      onClick={openLogin}
                    >
                      Log In / Register
                    </Link>
                    <div />
                    <Link className="get-started" to="/start">
                      Get Started
                    </Link>
                  </div>
                ) : (
                  <Tooltip title="Account settings">
                    <IconButton onClick={handleClick} size="medium">
                      <Avatar
                        style={{
                          border: "2px solid white",
                          background: "salmon",
                        }}
                        sx={{ width: 45, height: 45 }}
                        src={currentUser?.photoURL}
                      >
                        {currentUser?.displayName?.charAt(0)?.toUpperCase() ||
                          currentUser?.email?.charAt(0)?.toUpperCase()}
                      </Avatar>
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 30,
                      height: 30,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: "Update Profile",
                      content: <Profile />,
                    })
                  }
                >
                  <Avatar src={currentUser?.photoURL} /> Profile
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: "Account Settings",
                      content: <AccountSettings />,
                    })
                  }
                >
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>

              <div />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default ProfileNavbar;
